"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemDefinition = exports.GenericItemInstanceSchema = exports.GenericItemPrototypeSchema = exports.ITEM_TYPES = void 0;
const validation_1 = require("../../validation");
const zod_1 = require("zod");
exports.ITEM_TYPES = [
    "Amount",
    "Checkbox",
    "Checklist",
    "Custom",
    "CustomV2",
    "Date",
    "DateTime",
    "Email",
    "FileUploadV2",
    "Location",
    "MultiLineText",
    "MultiSelect",
    "Rating",
    "Schedule",
    "Signature",
    "SingleSelect",
    "SlackMessage",
    "Subquest",
    "Switch",
    "Text",
    "UserPicker",
    "Video",
];
/**
 * This schema may not match the DB schema for this type.
 * It is for use with validations
 * and shows the minimal data expected when validating an item prototype.
 */
exports.GenericItemPrototypeSchema = zod_1.z.object({
    name: zod_1.z.string((0, validation_1.labelZodErrors)("Name")).min(1, "Name must not be empty."),
    type: zod_1.z.enum(exports.ITEM_TYPES, (0, validation_1.labelZodErrors)("Item type")),
    config: zod_1.z.object({}, (0, validation_1.labelZodErrors)("Config")).passthrough(),
    customScript: zod_1.z.string((0, validation_1.labelZodErrors)("Custom Script")).nullable(),
    required: zod_1.z.boolean((0, validation_1.labelZodErrors)("Required")),
    isCompletionAction: zod_1.z.boolean((0, validation_1.labelZodErrors)("Is Completion Action")),
    position: zod_1.z.number((0, validation_1.labelZodErrors)("Position")),
});
const itemPrototypeSchemaValidator = (0, validation_1.createZodSchemaValidator)([], exports.GenericItemPrototypeSchema);
/**
 * This schema may not match the DB schema for this type.
 * It is for use with validations
 * and shows the minimal data expected when validating an item instance.
 */
exports.GenericItemInstanceSchema = zod_1.z.object({
    type: zod_1.z.enum(exports.ITEM_TYPES, (0, validation_1.labelZodErrors)("Item type")),
    config: zod_1.z.object({}, (0, validation_1.labelZodErrors)("Config")).passthrough(),
    data: zod_1.z.object({}, (0, validation_1.labelZodErrors)("Data")).passthrough(),
    required: zod_1.z.boolean((0, validation_1.labelZodErrors)("Required")),
    isCompletionAction: zod_1.z.boolean((0, validation_1.labelZodErrors)("Is Completion Action")),
});
const itemInstanceSchemaValidator = (0, validation_1.createZodSchemaValidator)([], exports.GenericItemInstanceSchema);
class ItemDefinition {
    itemType;
    configSchema;
    dataSchema;
    _configurationValidator;
    _submissionValidator;
    constructor(itemType, configSchema, dataSchema, _configurationValidator, _submissionValidator) {
        this.itemType = itemType;
        this.configSchema = configSchema;
        this.dataSchema = dataSchema;
        this._configurationValidator = _configurationValidator;
        this._submissionValidator = _submissionValidator;
    }
    get configurationValidator() {
        return new validation_1.ValidatorPipeline("Item Config Validator", [
            itemPrototypeSchemaValidator,
            (0, validation_1.createZodSchemaValidator)(["config"], this.configSchema),
            this._configurationValidator,
        ]);
    }
    get submissionValidator() {
        return new validation_1.ValidatorPipeline("Item Config Validator", [
            itemInstanceSchemaValidator,
            (0, validation_1.createZodSchemaValidator)(["data"], this.dataSchema),
            this._submissionValidator,
        ]);
    }
}
exports.ItemDefinition = ItemDefinition;
//# sourceMappingURL=ItemDefinition.js.map